import React 				from 'react';
import PropTypes 			from 'prop-types';
import BLComponent			from '../../core/_BLComponent.jsx';

export default class ErrorPage extends BLComponent {
	constructor(props) {
		super(props);
	}

    render() {
        const errorMsg = this.props.errorMsg;
        const button = this.props.button;
        const messageContent = errorMsg.map( (msg, idx) => {
            return( 
                <div key={"_err_msg_" + idx}>
                    {msg}
                </div>
            )
        });
       
        return(
            <div className="l-margin-x--auto text--center error-page__body--mid">
                <div className="error-page__body-icon--mid l-pad-bottom--s">
                    <i className="fas fa-exclamation-triangle text-color--primaryRed"></i> 
                </div>
                <div className="l-margin-top--xl">
                    {messageContent}
                </div>
                {(typeof button !== "undefined")&&
                <div className="l-margin-top--xl">
                    <button className={ button.class} onClick={()=>button.action()}>
                        {button.name}
                    </button>
                </div>
                }
            </div>
        )
    }
}